export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const endPointName = {
  Master: {
    getCountry: 'countryMaster/GetCountryMaster',
    getState: 'stateMaster/GetStateMaster',
    getDistrict: 'districtMaster/GetDistrictMaster',
    getExpertise: 'expertiseMaster/GetExpertiseMaster',
    getDocument: 'documentMaster/GetDocumentMaster',
    getAssociate: 'AssociateMaster/GetAssociateMaster',
    getMembership: 'MembershipMaster/GetMembershipMaster',
    getAdminRole: 'AdminRoleMaster/GetAdminRoleMaster',
    getAdminRoleAccess: 'AdminRoleAccessMaster/GetAdminRoleAccessMaster',
    getModuleAccess: 'AdminModuleAccessMaster/GetAdminModuleAccessMaster',
    religion: 'ReligionMaster/GetReligionMaster',
    community: 'Community/GetCommunityMaster',
    eventType: 'Events/GetEventTypeMaster'
  },
  Admin: {
    authorize: 'AdminPanelLogin/AuthorizeUser',
    adminInsertUpdate: 'AdminUserData/AdminUserDataInsert',
    getProfile: 'AdminPanelLogin/GetAuthorizedUserProfile',
    adminList: 'AdminUserData/GetAdminUsersList',
    adminDetails: 'AdminUserData/GetAdminUserDetails',
    sendOtp: 'Verification/MobileNumberVerification',
    verifyOtp: 'Verification/MobileNumberOTPVerification',
    sendEmailOtp: 'Verification/EmailIdVerification',
    verifyEmailOtp: 'Verification/EmailIdOTPVerification',
    loginOTPSend: 'MobileLogin/MobileLoginVerification',
    loginOTPVerify: 'MobileLogin/MobileLoginOTPVerification',
    AdminUserDataUpdate: 'AdminUserData/AdminUserDataUpdate',
    forgotPassword: 'MobileLogin/CheckUserForForgetPassword',
    UpdatePassword: 'AdminPanelLogin/UpdatePassword',
    AdminforgotPassword: 'MobileLogin/EmailForgetPassword',
    deleteAdmin: 'AdminUserData/DeleteAdminUser',
    adminUpdate: 'AdminUserData/ApproveRejectAdmin'
  },
  Volunteer: {
    volunteerList: 'Volunteer/GetVolunteerList',
    volunteerInsert: 'Volunteer/VolunteerInsert',
    GetVolunteerDetails: 'Volunteer/GetVolunteerDetails',
    volunteerApproval: 'Volunteer/VolunteerApproveRejectBlock',
    VolunteerUpdate: 'Volunteer/VolunteerUpdate',
    forwardVolunteer: 'Volunteer/VolunteerForward',
    volunteerBecomeMember: 'Volunteer/VolunteerBecomeMember',
    asignmentVolunteerList: 'TokenAssignment/GetVolunteerListforTokenAssignment',
    insertTraining: 'Volunteer/VolunteerSpecialTraining',
    trainingList: 'Volunteer/VolunteerListTraining',
    tagAsign: 'Volunteer/VolunteerTags'
  },
  Member: {
    memberInsert: 'Membership/MembershipInsert',
    memberList: 'Membership/GetMembershipList',
    memberApproval: 'Membership/MembershipApproveRejectBlock',
    memberDetails: 'Membership/GetMembershipDetails',
    forwardMember: 'Membership/MembershipForward',
    memberListBasedOnType: 'Membership/GetMembershipListByTypeCreatedBy',
    referenceInsert: 'MemberReferenceNo/MemberReferenceNoInsert',
    memberBcomeVolunteer: 'Membership/MembershipBecomeVolunteer',
    referenceList: 'MemberReferenceNo/MemberReferenceNoList',
    MembershipUpdate: 'Membership/MembershipUpdate',
    referenceDetails: 'MemberReferenceNo/GetMemberReferenceNoDetails',
    deleteMember: 'MemberReferenceNo/MemberReferenceNoDelete',
    exportToExcel: 'MemberReferenceNo/MembersDataExport',
    transferReference: 'MemberReferenceNo/TransferReferenceNumber',
    closeReferenceNo: 'MemberReferenceNo/CloseReferenceNumber'
  },
  Donation: {
    donationInsert: 'Donation/DonationInsert',
    donationPercentageInsert: 'MemberReferenceNo/PercentageShareInsert',
    percentageList: 'MemberReferenceNo/GetPercentageShareList',
    updatePercentage: 'MemberReferenceNo/PercentageShareUpdate',
    deletePerentage: 'Membership/GetMembershipDetails',
    getDonorList: 'Donation/GetDonorsList',
    getDonorDetails: 'Donation/GetDonorsDetails'
  },
  Beneficiary: {
    GetBeneficiaryList: 'Beneficiary/GetBeneficiaryList',
    getVolunteerList: 'Volunteer/GetVolunteerListforBeneficiary',
    GetBeneficiaryDetails: 'Beneficiary/GetBeneficiaryDetails'
  },
  Thalassemia: {
    ThalassemiaInsert: 'Thalassemia/ThalassemiaInsert',
    getThalassemiaList: 'Thalassemia/GetThalassemiaList',
    getThalassemiaDetails: 'Thalassemia/GetThalassemiaDetails'
  },
  BloodDonation: {
    BloodDonationCampInsert: 'BloodDonationCamp/BloodDonationCampInsert',
    GetBloodDonationCampList: 'BloodDonationCamp/GetBloodDonationCampList'
  },
  Event: {
    createEvent: 'Events/EventInsert',
    eventList: 'Events/GetEventsListForAdmin',
    eventDetails: 'Volunteer/GetVolunteerDetails',
    updateEvent: 'Events/EventUpdate',
    closeEvent: 'Events/EventClose',
    getEventbasedOnType: 'Events/GetEventsListForAdminBasedOnEventType',
    latest_event_details: 'Events/GetEventDetails'
  },
  Token: {
    createToken: 'Tokens/TokenInsert',
    tokenList: 'Tokens/GetAdminTokensList',
    tokenDetails: 'Volunteer/GetVolunteerDetails',
    updateToken: '',
    tokenBeneficiaryList: 'Tokens/GetAdminBeneficiaryList',
    tokenAsignment: 'TokenAssignment/TokenAssignToVolunteer',
    beneficiaryforTokenCreation: 'Tokens/GetAdminBeneficiaryListForTokenCreation',
    latest_token_details: 'Tokens/GetTokenDetails'
  },
  Items: {
    createItem: 'ItemsMaster/ItemMasterInsert',
    itemList: 'ItemsMaster/GetItemsMaster',
    updateItem: 'ItemsMaster/ItemMasterUpdate',
    deleteItem: 'ItemsMaster/ItemMasterDelete',
    inventory: 'ItemsMaster/ItemDetails'
  },
  Timesheet: {
    create: 'Timesheet/TimesheetInsert',
    list: 'Timesheet/GetTimesheetList',
    update: 'Timesheet/TimesheetUpdate',
    delete: 'ItemsMaster/ItemMasterDelete',
    approveReject: 'Timesheet/TimesheetApprovalReject'
  },
  Dashboard: {
    GetDashboardData: 'Dashboard/GetDashboardData'
  },
  itemStock: {
    ItemStcok: 'Volunteer/GetVolunteerList'
  },
  offlineMember: {
    offlineMemberList: 'OfflineMembership/GetOfflineMembershipList',
    offlineMemberDetails: 'OfflineMembership/GetOfflineMembershipDetails',
    createOfflineMember: 'OfflineMembership/InsertOfflineMembership',
    updateOfflineMember: 'OfflineMembership/UpdateOfflineMembershipdetails',
    deleteOfflineMember: 'OfflineMembership/DeleteOfflinemembershipDetails', // not in use
    offlineMemberListBasedOnType:
      'OfflineMembershipReference/GetOfflineMembershipListByTypeCreatedBy',
    offlineMemberReferenceInsert: 'OfflineMembershipReference/OfflineMemberReferenceNoInsert',
    offlineMemberReferenceList: 'OfflineMembershipReference/OfflineMemberReferenceNoList',
    referenceDetails: 'OfflineMembershipReference/OfflineMemberReferenceNoDetails',
    deleteMember: 'OfflineMembershipReference/DeleteOfflineMemberReference',
    ReferenceDispatch: 'OfflineMembershipReference/DispatchOfflineReference',
    transferReference: 'OfflineMembershipReference/OfflineMemberTransferred',
    referenceClose: 'OfflineMembershipReference/CloseOfflineReference',
    exportToExcel: 'OfflineMembershipReference/ExportOfflineMemberReferenceToExcel',
    ReferenceRecieved: 'OfflineMembershipReference/CertificateRecievedAPI',
    memberPayment: 'OfflineMembership/MembershipPayment'
  },
  requestPermission: {
    requestList: 'OfflineMembership/GetOfflineMembershipList',
    createRequest: 'OfflineMembership/InsertOfflineMembership',
    updateRequest: 'OfflineMembership/UpdateOfflineMembershipdetails',
    rejectRequest: 'OfflineMembership/DeleteOfflinemembershipDetails'
  }
};
